/**
 * Coordinates AuthLayout auto-redirect so post-signup success UI can remain
 * mounted while the user is already authenticated.
 *
 * Uses a tiny external store so AuthLayout re-renders via useSyncExternalStore
 * when the signup hook toggles suppression.
 */

type Listener = () => void;

let suppressAuthLayoutRedirect = false;
const listeners = new Set<Listener>();

function emit(): void {
  listeners.forEach((listener) => listener());
}

export function setAuthLayoutRedirectSuppressed(suppressed: boolean): void {
  const next = Boolean(suppressed);
  if (next === suppressAuthLayoutRedirect) return;
  suppressAuthLayoutRedirect = next;
  emit();
}

export function isAuthLayoutRedirectSuppressed(): boolean {
  return suppressAuthLayoutRedirect;
}

export function subscribeAuthLayoutGate(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getAuthLayoutRedirectSuppressedSnapshot(): boolean {
  return suppressAuthLayoutRedirect;
}
